<div class="alert alert-dismissible d-flex align-items-center fade customMessage" [ngClass]="{'show': showMessage == true, 'alert-success': alertType== 1, 'alert-danger': alertType== 0}">
  <i class="bi-check-circle-fill" *ngIf="alertType== 1"></i>
  <i class="bi bi-exclamation-octagon p-1" *ngIf="alertType== 0"></i>
  &nbsp;{{ message}}
  <button type="button" class="btn-close" data-bs-dismiss="alert"></button>
</div>
